export default {"src":"/_next/static/media/warning_icon.0926a602.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};